import { Box, useColorMode, useMediaQuery } from "@chakra-ui/react";
import About from "./components/About";

import Header from "./components/Header";
import NavBar from "./components/Navbar";
import Newnav from "./components/newnav";

import Projects from "./components/Projects";
import './App.css'
function App() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";
   const [isNotSmall] = useMediaQuery("(min-width: 1100px)");
  return (
    <Box className="App" bg={isDark? 'rgb(26,32,43)' : 'rgb(255,255,255)'}>
      
      
      {isNotSmall ? <Newnav change={toggleColorMode} dark={isDark} /> : <NavBar className='nav' change={toggleColorMode} dark={isDark}/>}
      <Header />
      <About />
      <Projects />
      
    </Box>
    
  );
}

export default App;
